import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Teleport as _Teleport, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0fa6d20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-search-result-main" }
const _hoisted_2 = { class: "the-search-result-main-header" }
const _hoisted_3 = { class: "myCollection-header" }
const _hoisted_4 = { class: "main-head" }
const _hoisted_5 = { class: "keywordSearch-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "the-search-result-main-total",
  id: "search-result-total-hits-message"
}
const _hoisted_7 = {
  key: 0,
  class: "has-text-title has-text-contents-title",
  id: "search-result-total-hits-message"
}
const _hoisted_8 = { id: "itemTotalHits" }
const _hoisted_9 = {
  key: 1,
  class: "has-text-title has-text-contents-title",
  id: "search-result-total-hits-message"
}
const _hoisted_10 = { id: "itemTotalHits" }
const _hoisted_11 = {
  key: 0,
  id: "error-message"
}
const _hoisted_12 = { class: "the-search-result-main-show-facet level-right is-mobile is-hidden-desktop has-background-contents" }
const _hoisted_13 = { class: "the-search-result-main-nav is-hidden-mobile level-right has-background-contents" }
const _hoisted_14 = { class: "modal-my-collection-sorting" }
const _hoisted_15 = { class: "the-search-result-main-nav-mobile" }
const _hoisted_16 = { class: "has-background-contents shadow" }
const _hoisted_17 = { class: "has-text-table-cell-title" }
const _hoisted_18 = { class: "modal-wrapp modal-sheet-mobile" }
const _hoisted_19 = {
  key: 1,
  class: "the-search-result-main-item-list"
}
const _hoisted_20 = {
  key: 0,
  class: "search-not-found"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_KeywordSearch = _resolveComponent("KeywordSearch")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_CloserController = _resolveComponent("CloserController")!
  const _component_RadioButtonList = _resolveComponent("RadioButtonList")!
  const _component_TheMyCollectionLeftColumn = _resolveComponent("TheMyCollectionLeftColumn")!
  const _component_ModalSheetMobile = _resolveComponent("ModalSheetMobile")!
  const _component_TheMyCollectionItemListView = _resolveComponent("TheMyCollectionItemListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DssIcon, { icon: 'bookmark-fill' }),
        (_ctx.tagName === 'すべて')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t('label.all')), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.tagName), 1)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KeywordSearch, {
            placeholder: _ctx.$t('label.keyword'),
            class: "facet-item-keyword",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            label: _ctx.$t('message.doSearch')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppButton, {
                styled: "is-none",
                type: "submit",
                label: _ctx.$t('parts.search')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('parts.search')), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["placeholder", "modelValue", "label"])
        ]),
        (!_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.myCollectionItemCount > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.searchResult')) + " ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.toLocale(_ctx.myCollectionItemCount, _ctx.lang)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('label.showCase')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.searchResult')) + " ", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.toLocale(_ctx.myCollectionItemCount, _ctx.lang)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('label.case')), 1)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["the-search-result-main-posts", {
          'list-view': _ctx.state.displayMode === _ctx.VIEW_TYPE_LIST_ITEM,
          'thumbnail-view': _ctx.state.displayMode === _ctx.VIEW_TYPE_THUMBNAIL
        }])
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_AppButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal())),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.showModal()), ["prevent"]), ["space","enter"])),
                class: "button-normal the-app-button-my-collection-sorting",
                styled: "is-normal",
                id: "sorting-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.sorting')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("nav", _hoisted_13, [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.state.displayMode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.displayMode) = $event)),
                options: _ctx.displayModeLocale,
                componentId: "the-selectbox-display-mode"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.state.displayedItemViewPattern,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.displayedItemViewPattern) = $event)),
                options: _ctx.displayItemViewPatternList,
                componentId: "the-selectbox-contents-show"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.sort,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sort) = $event)),
                options: _ctx.sortList,
                componentId: "the-selectbox-sort-key"
              }, null, 8, ["modelValue", "options"])
            ]),
            (_ctx.state.showModal)
              ? (_openBlock(), _createBlock(_Teleport, {
                  key: 0,
                  to: "#mobile-mycollection-menu"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ModalSheetMobile, {
                      show: _ctx.state.showModal,
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.showModal = false)),
                      title: _ctx.$t('form.sorting')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("section", _hoisted_16, [
                            _createVNode(_component_CloserController, {
                              modelValue: _ctx.state.showSortList,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.showSortList) = $event)),
                              icons: ['accordion-open', 'arrow-right'],
                              class: "has-background-modest"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('form.order')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (_ctx.state.showSortList)
                              ? (_openBlock(), _createBlock(_component_RadioButtonList, {
                                  key: 0,
                                  modelValue: _ctx.sort,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sort) = $event)),
                                  items: _ctx.sortList.map((item) => ({ label: item.name, value: item.value })),
                                  class: "has-text-contents-normal has-form-text-normal",
                                  id: "sort-type",
                                  name: "sort-type",
                                  mobileFlag: true
                                }, null, 8, ["modelValue", "items"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_TheMyCollectionLeftColumn, {
                            class: "search-result-side",
                            onTagSelected: _ctx.tagSelected
                          }, null, 8, ["onTagSelected"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["show", "title"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.myCollectionItemCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myCollections, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_ctx.isDisplayItem(item))
                        ? (_openBlock(), _createBlock(_component_TheMyCollectionItemListView, {
                            class: "the-search-result-main-item-article",
                            tag: "article",
                            index: index,
                            item: item,
                            isItem: item.isItem || false,
                            displayMode: _ctx.state.displayMode,
                            contentListViewHandler: _ctx.state.displayedItemViewPattern,
                            key: `TheMyCollectionItemListView_${item.pid}_${index}`
                          }, null, 8, ["index", "item", "isItem", "displayMode", "contentListViewHandler"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.myCollectionItemCount === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('label.notFound')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}